import script from "./transactionsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./transactionsChart.vue?vue&type=script&setup=true&lang=js"

import "./transactionsChart.vue?vue&type=style&index=0&id=f82cac36&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f82cac36"]])

export default __exports__